<template>
    <div class="badge-dot badge-class" v-if="!is_show" :style="'top:-'+(size/2)+'px;right:-'+size+'px;height:'+size+'px;width:'+size+'px'">
    </div>
</template>

<script>
    export default {
        name: "badge_dot",
        props:{
            is_show: {
                type:Boolean | Number,
                default:false
            },
            size:{
                type:Number,
                default:8
            }
        }
    }
</script>

<style scoped>
    .badge{
        position: relative;
        display: inline-block;
        line-height: 1;
        vertical-align: middle;
    }
    .badge-dot{
        position: absolute;
        transform: translateX(-50%);
        transform-origin: 0 center;
        top: -4px;
        right: -8px;
        height: 8px;
        width: 8px;
        border-radius: 100%;
        background: #ed3f14;
        z-index: 10;
        box-shadow: 0 0 0 1px #fff;
    }
</style>
